import React from "react";
import { IonCard, IonCardContent, IonText } from "@ionic/react";

type StatCardProps = {
  title: string;
  subtitle?: string;
  count?: number;
  amount?: number;
  currency?: string;
};

function formatMoney(value: number, currency = "TJS") {
  return new Intl.NumberFormat("ru-RU").format(value) + ` ${currency}`;
}

export const StatCard: React.FC<StatCardProps> = ({
  title,
  subtitle,
  count,
  amount,
  currency = "TJS",
}) => {
  return (
    <IonCard className="m-0 rounded-2xl border border-gray-100 shadow-sm">
      <IonCardContent className="p-4">
        <div className="flex items-start justify-between gap-3">
          <div>
            <IonText className="text-sm font-medium text-gray-900">
              <h3>{title}</h3>
            </IonText>
            {subtitle && (
              <p className="mt-1 text-xs text-gray-500">{subtitle}</p>
            )}
          </div>
        </div>

        <div className="mt-4 grid grid-cols-2 gap-3">
          <div className="rounded-xl bg-gray-50 p-3">
            <p className="text-xs text-gray-500">Количество</p>
            <p className="mt-1 text-xl font-semibold text-gray-900">
              {typeof count === "number" ? count : "—"}
            </p>
          </div>

          <div className="rounded-xl bg-gray-50 p-3">
            <p className="text-xs text-gray-500">Сумма</p>
            <p className="mt-1 text-xl font-semibold text-gray-900">
              {typeof amount === "number" ? formatMoney(amount, currency) : "—"}
            </p>
          </div>
        </div>
      </IonCardContent>
    </IonCard>
  );
};